var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'card': _vm.showNavigation },attrs:{"id":"app"}},[(_vm.showNavigation)?_c('site-navigation'):_vm._e(),_vm._v(" "),_c('offline-mode'),_vm._v(" "),(_vm.showNavigation)?_c('feedback'):_vm._e(),_vm._v(" "),_c('loading'),_vm._v(" "),(!_vm.isAppLoading)?_c('router-view'):_vm._e(),_vm._v(" "),_c('help'),_vm._v(" "),_c('privacy'),_vm._v(" "),_c('disclaimer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc70ee44","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = nyoq
// module chunks = 1